import styled from 'styled-components';
import QuestionIcon from '@/assets/icon/question.svg?react';
import GraphIcon from '@/assets/icon/graph.svg?react';
import RoadIcon from '@/assets/icon/road.svg?react';

export default function Description() {
  return (
    // <SectionWrapper>
    //   <Wrapper>
    <>
      <Content>
        {/* <TextGroup>
          <SubTitle>왜, 올받음인가?</SubTitle>
          <MainTitle>
            올받음에서는 신청만 하면,
            <br /> 당신의 보험금 가능성을 열어드립니다
          </MainTitle>
        </TextGroup> */}

        <CardRow>
          <Card>
            <CardContent>
              <CardTop>
                <CardLabel>첫번째</CardLabel>
                <CardTitle>
                  무료인지 유료인지,
                  <br /> 고민하실 필요 없습니다
                </CardTitle>
              </CardTop>
              <CardBottom>
                <CardDescription>
                  바로 신청하세요.
                  <br /> 올받음이 상황을 판단하여 무료 선임이 가능한지,
                  <br /> 유료 선임이 필요한지 정확히 알려드립니다
                </CardDescription>
                <CardIcon>
                  <QuestionIcon />
                </CardIcon>
              </CardBottom>
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              <CardTop>
                <CardLabel>두번째</CardLabel>
                <CardTitle>
                  보험회사와 전혀 이해관계 없는
                  <br /> 독립손해사정사입니다
                </CardTitle>
              </CardTop>
              <CardBottom>
                <CardDescription>
                  <br />
                  보험사 입장의 손해사정이 걱정되시나요?
                  <br /> 이제 중립적인 올받음 손해사정사를 만나보세요
                </CardDescription>
                <CardIcon>
                  <RoadIcon />
                </CardIcon>
              </CardBottom>
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              <CardTop>
                <CardLabel>세번째</CardLabel>
                <CardTitle>
                  손해사정사 선임 제도도
                  <br /> 노하우가 필요합니다
                </CardTitle>
              </CardTop>
              <CardBottom>
                <CardDescription>
                  <br /> 손해사정사 선임권 '1위', 2023년/2024년 연속
                  <br /> 올받음은 수천 건의 실적으로 증명합니다
                </CardDescription>
                <CardIcon>
                  <GraphIcon />
                </CardIcon>
              </CardBottom>
            </CardContent>
          </Card>
        </CardRow>
      </Content>
    </>
  );
}

// const SectionWrapper = styled.section`
//   width: 100%;
//   padding: 0 16px;
//   @media (max-width: 768px) {
//     padding: 0 16px;
//   }
// `;

// const Wrapper = styled.div`
//   display: flex;
//   max-width: 1220px; /* ✅ 추가 */
//   padding: 32px;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   gap: 60px;
//   border-radius: 24px;
//   background: var(--Primary-darkgray, #000c24);
//   margin: 0 auto;
//   margin-top: 185px;
//   text-align: start;

//   @media (max-width: 768px) {
//     padding: 24px 16px;
//     gap: 40px;
//     margin-top: 120px;
//   }
// `;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding-top: 120px;

  @media (max-width: 768px) {
    padding-top: 80px;
  }
`;

// const TextGroup = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   gap: 16px;
// `;

// const SubTitle = styled.div`
//   align-self: stretch;
//   color: var(--Primary-lightgray, #f3f3f3);
//   text-align: center;
//   font-size: 20px;
//   font-style: normal;
//   font-weight: 400;
//   line-height: 150%;
//   letter-spacing: -0.4px;

//   @media (max-width: 768px) {
//     font-size: 16px;
//   }
// `;

// const MainTitle = styled.div`
//   align-self: stretch;
//   color: var(--Primary-white, #fff);
//   text-align: center;
//   font-size: 32px;
//   font-style: normal;
//   font-weight: 700;
//   line-height: 150%;
//   letter-spacing: -0.64px;

//   @media (max-width: 768px) {
//     font-size: 22px;
//     line-height: 160%;
//   }
// `;

const CardRow = styled.div`
  display: flex;
  flex-wrap: wrap; /* ✅ 줄바꿈 허용 */
  gap: 27px;
  justify-content: center; /* ✅ 가운데 정렬 */
  width: 100%;

  @media (max-width: 1024px) {
    gap: 20px;
  }
`;

const Card = styled.div`
  flex: 1 1 calc(33.333% - 18px); /* ✅ 3개 배치 기준 */

  max-width: 367px;
  min-width: 280px;
  display: flex;
  padding: 24px 32px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  border-radius: 8px;
  background: var(--Primary-darkgray, #000c24);

  @media (max-width: 1024px) {
    flex: 1 1 calc(50% - 18px); /* ✅ 태블릿은 2개 */
  }

  @media (max-width: 640px) {
    flex: 1 1 100%; /* ✅ 모바일은 1개 */
    padding: 20px;
  }
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
  align-self: stretch;
`;

const CardTop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

const CardLabel = styled.div`
  align-self: stretch;
  color: #dd8c0b;
  font-family: 'Noto Sans KR';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;
`;

const CardTitle = styled.div`
  align-self: stretch;
  color: var(--Primary-white, #fff);
  font-family: 'Noto Sans KR';
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.4px;

  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 150%;
  }
`;

const CardBottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;

  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 150%;
    display: none;
  }
`;

const CardDescription = styled.div`
  align-self: stretch;
  color: var(--Primary-lightgray, #f3f3f3);
  font-family: 'Noto Sans KR';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

const CardIcon = styled.div`
  display: flex;
  height: 54px;
  padding-right: 221.891px;
  align-items: center;
  align-self: stretch;

  @media (max-width: 768px) {
    padding-right: 0;
    justify-content: start;
  }
`;
